__turbopack_context__.v({
  "carSelectedWrapper": "_1FtpNW_carSelectedWrapper",
  "carsListWrapper": "_1FtpNW_carsListWrapper",
  "iconWrapperUsp": "_1FtpNW_iconWrapperUsp",
  "itemWrapper": "_1FtpNW_itemWrapper",
  "mainContent": "_1FtpNW_mainContent",
  "textWrapper": "_1FtpNW_textWrapper",
  "warningMessageWrapper": "_1FtpNW_warningMessageWrapper",
});
